import { render, staticRenderFns } from "./AddWorkFlowModal.vue?vue&type=template&id=257820e4&scoped=true"
import script from "./AddWorkFlowModal.vue?vue&type=script&lang=js"
export * from "./AddWorkFlowModal.vue?vue&type=script&lang=js"
import style0 from "./AddWorkFlowModal.vue?vue&type=style&index=0&id=257820e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257820e4",
  null
  
)

export default component.exports